<script>
  import options from './DeliveryAddress.options'
  export default options
</script>

<template>
  <article class="kb-forms kb-delivery-address">

    <h3 class="kb-delivery-address__title">{{getLabel('title')}}</h3>

    <!-- reusing relevant styles from checkout step one -->
    <div class="kb-checkout-step-one__form-wrapper">
        <FormInputTextField
          v-model="deliveryNameInput" 
          fieldName="deliveryName" 
          autocomplete="organization" 
          :label="getLabel('deliveryNameLabel')"
          :placeholder="getLabel('deliveryNamePlaceholder')"   
          :isValidationError="!deliveryNameInputFilled"
          :onChangeCallback="handleSendToStore"
          :errorMessageLabel="getLabelCheckout('validationGeneral')" 
        />

        <FormInputTextField
          v-model="deliveryDepartmentInput" 
          fieldName="deliveryDepartment" 
          autocomplete="off" 
          :label="getLabel('deliveryDepartmentLabel')"
          :placeholder="getLabel('deliveryDepartmentPlaceholder')"    
          :isValidationError="!deliveryDepartmentInputFilled"
          :onChangeCallback="handleSendToStore"
          :errorMessageLabel="getLabelCheckout('validationGeneral')" 
        />
    </div>

    <div class="kb-checkout-step-one__form-wrapper">
        <FormInputTextField 
          isRequired
          v-model="firstNameInput" 
          fieldName="firstName" 
          autocomplete="given-name" 
          :label="getLabel('firstNameLabel')"
          :placeholder="getLabel('firstNamePlaceholder')"   
          :isValidationError="!firstNameInputFilled"
          :errorMessageLabel="getLabel('validationFirstName')" 
          :onChangeCallback="handleSendToStore"
        />

        <FormInputTextField 
          isRequired
          v-model="lastNameInput" 
          fieldName="lastName" 
          autocomplete="family-name" 
          :label="getLabel('lastNameLabel')"
          :placeholder="getLabel('lastNamePlaceholder')"    
          :isValidationError="!lastNameInputFilled"
          :errorMessageLabel="getLabel('validationLastName')" 
          :onChangeCallback="handleSendToStore"
        />
      </div>

      <div class="kb-checkout-step-one__form-wrapper">
        <FormAddressField 
          v-model:address-line-value="addressLineInput" 
          v-model:zip-code-value="postalCodeInput" 
          v-model:city-value="cityInput"
          :addressLabel="getLabel('addressLineLabel')" 
          :zipCodeLabel="getLabel('postalCodeLabel')"
          :addressPlaceholder="getLabel('addressLinePlaceholder')"  
          :zipCodePlaceholder="getLabel('postalCodePlaceholder')"  
          :cityPlaceholder="getLabel('cityPlaceholder')"  
          :cityLabel="getLabel('cityLabel')" 
          :isValidationError="!addressLineInputFilled && !postalCodeInputFilled && !cityInputFilled"
          :errorMessageLabel="getLabel('validationAddressLine')" 
          :onchangeCallback="handleSendToStore"
        />
      </div>

  </article>
</template>
